import { ModelBase } from 'store/model-base';
import { AddonStatus, AddonType, Frequency, FrequencyLabel } from 'my-account/constants';
import { Util } from 'services/util';

export class Addon extends ModelBase {
    public endDate: string;
    public frequency: string;
    public name: string;
    public planId: string;
    public price: number;
    public removalRequestCode: string;
    public state: AddonStatus;
    public displayPrice: string;
    public type: AddonType;
    public session: AddonSession;

    public isActive: boolean;
    public isPendingRemoval: boolean;
    public isInactive: boolean;
    public isHdPass: boolean;
    public isMexicoCanadaPass: boolean;
    public isGtp: boolean;
    public isMexCanOrGtp: boolean;

    public static create<T extends ModelBase>(response: ApiResponse): T {
        const toReturn: Addon = super.create<Addon>(response);

        toReturn.frequency = toReturn.frequency === Frequency.MONTHLY ? FrequencyLabel.MONTHLY : FrequencyLabel.DAILY;
        toReturn.displayPrice = `$${toReturn.price}/${toReturn.frequency}`;

        toReturn.isActive = toReturn.state === AddonStatus.ACTIVE;
        toReturn.isPendingRemoval = toReturn.state === AddonStatus.PENDING_REMOVAL;
        toReturn.isInactive = toReturn.state === AddonStatus.INACTIVE;

        toReturn.isHdPass = toReturn.type === AddonType.HD_PASS;
        toReturn.isMexicoCanadaPass = toReturn.type === AddonType.MEX_CAN_PASS || toReturn.type === AddonType.CAN_MEX_UNL_PASS;
        toReturn.isGtp = toReturn.type === AddonType.GTP;
        toReturn.isMexCanOrGtp = (toReturn.type === AddonType.MEX_CAN_PASS || toReturn.type === AddonType.CAN_MEX_UNL_PASS || toReturn.type === AddonType.GTP);

        if (toReturn.endDate) {
            toReturn.endDate = Util.dateFormat(toReturn.endDate, 'MMM d');
        }

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }
}
